import { api, leerSesion, puede, type Cita } from "./api.ts";
import { datosDelDia, resumenDelDia } from "../../dominio/src/index.ts";
import { azar } from "./habla.ts";

/** El saludo y cómo va el día de la persona (sus citas de hoy), en una frase para leer o escuchar. Nunca lleva nombres de pacientes. */
export async function resumenDeHoy(): Promise<string> {
  if (!puede("agenda:leer")) return "Tu rol no ve la agenda, así que hoy no tengo un resumen para ti. Dime en qué más te ayudo.";
  const ahora = new Date();
  const dia = ahora.toLocaleDateString("sv-SE");
  const citas = await api<Cita[]>("GET", `/api/citas?desde=${dia}&hasta=${dia}`);
  const hhmm = `${String(ahora.getHours()).padStart(2, "0")}:${String(ahora.getMinutes()).padStart(2, "0")}`;
  return resumenDelDia(datosDelDia(citas.map((c) => ({ estado: c.estado, hora: c.hora })), hhmm), { nombre: leerSesion()?.usuario.nombre, hora: ahora.getHours(), azar });
}
